// Endereço oficial do site: canonical, og:url e sitemap sempre apontam para cá (nunca para www, run.app ou dev).
export const SITE_URL = "https://calriz.com";
export const SITE_NAME = "Calriz";
export const DEFAULT_IMAGE = "/og-image.jpg";

export const absoluteUrl = (path: string) => (/^https?:\/\//.test(path) ? path : `${SITE_URL}${path}`);

export const ORGANIZATION_REF = { "@type": "Organization", name: SITE_NAME, url: SITE_URL };
